import React from "react";
import image from "../../../images/sfs-outlook-addin-login-Iframe.png";

const BrandingContent: React.FC = () => (
  <div
    style={{
      height: "730px",
      width: "370px",
      backgroundImage: `url(${image})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
    }}
  ></div>
);

export default BrandingContent;
